// Importing Fucking Packages
import React, {useState} from 'react';
import About from './Components/About';
import Content from './Components/Content';
import Navbar from './Components/Navbar';
import Contact from './Components/Contact';
import {BlogHandler} from './Components/BlogHandler';
import {Post} from './Components/Post';
import {Dashboard} from './Components/Dashboard/Dashboard';
import {DblogHandler} from './Components/Dashboard/DblogHandler';
import {ProjectHandler} from './Components/ProjectHandler';
import {EditBlog} from './Components/Dashboard/editBlog';
import {
  HashRouter as Router,
  Switch,
  Route
} from 'react-router-dom';
import './prism.css';
import './sbuttons.min.css';
import './style.css';
import './bootstrap.min.css';
// Creating App function
export default function App() {
  return (
    // Handling Router
    <Router>
      <Switch>
        {/* Landing Page Route Paths */}
        <Route exact path = "/">
          <Navbar title = "EklavyaDev" />
          <Content title = "EklavyaDev" />
        </Route>
        <Route path = "/about">
          <Navbar title = "EklavyaDev"/>
          <About/>
        </Route>
        <Route path = "/contact">
          <Navbar title = "EklavyaDev"/>
          <Contact/>
        </Route>
        <Route exact path = "/blog">
          <Navbar title = "EklavyaDev"/>
          <BlogHandler/>
        </Route>
        <Route exact path = "/blog/:id">
          <Navbar title = "EklavyaDev"/>
          <Post/>
        </Route>
        <Route exact path = "/dashboard">
          <Navbar title = "EklavyaDev"/>
          <Dashboard/>
          <DblogHandler />
          <br/>
        </Route>
        <Route exact path = "/projects">
          <Navbar title = "EklavyaDev"/>
          <ProjectHandler/>
        </Route>
        <Route path = "/dashboard/edit/:id">
          <Navbar title = "EklavyaDev"/>
          <EditBlog/>
        </Route>
      </Switch>
    </Router>
  );
}
